import StatusChip from "@entrilia/shared/components/StatusChip";
import { getCategoryTagColor } from "@entrilia/shared/utilities/categoryColor";
import type { InvestorCommunicationCategory } from "../../api/types/investorCommunicationsTypes";

interface Props {
  category: InvestorCommunicationCategory;
}

const NewsCategoryTag = ({ category }: Props) => {
  return <StatusChip label={category.name} color={getCategoryTagColor(category.color)} />;
};

export default NewsCategoryTag;
